
































import Vue from 'vue'

import { QAQC, FindQAQC } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      QAQCs: [] as QAQC[],
    }
  },

  methods: {
    async findQAQC() {
      this.QAQCs = await FindQAQC()
    },

    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    onRowClick(qaqc: QAQC) {
      this.$router.push({
        path: `/cems/setting/qaqc/${qaqc.id}`,
      })
    },

    gotoCreateForm() {
      this.$router.push({
        path: '/cems/setting/qaqc/create',
      })
    },
  },

  async created() {
    await this.findQAQC()
  },
})
